import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import { FC } from "react";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { useApp } from "../../hooks/useApp";
import { cancelSubscription } from "../../types/auth/CancelSubscription";


import {ReactComponent as Logo } from "../../resources/images/asap.svg";
//import { useAuth } from "../../../context/AuthContext";
import { CONSTANT } from "../../utils/Constants";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import MessageManager from "../../components/MessageManager";
import { Content, LinkTo } from "../styles";

const CancelSubscription: FC = () => {

  const theme = useTheme();
  const {
    isLoading,
    successMsg,
    errorMsg,
    resetErrorMsg,
    resetSuccessMsg,
    onSubmitCancelSubscription,
  } = useApp();

  // const {
  //   onSubmitCancelSubscription,
  // } = useAuth();

  const validation = Yup.object().shape({
    username: Yup.string()
      .required("Email es requerido")
      .email("Email es invalido"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<cancelSubscription>({
    resolver: yupResolver(validation),
  });

  return (
    <>
      {errorMsg && (
        <MessageManager
          type={CONSTANT.ERROR_MSG}
          msg={errorMsg}
          details=""
          callback={resetErrorMsg}
        />
      )}
      {successMsg && (
        <MessageManager
          type={CONSTANT.SUCCESS_MSG}
          msg={successMsg}
          details=""
          callback={resetSuccessMsg}
        />
      )}
      {isLoading && <Loading />}

      <Content
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ mt: -6, py: 4 }}
      >
        <Logo />
        <Stack
          flexDirection={"row"}
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "430px",
            maxWidth: "100%",
            position: "relative",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              fontSize: "1.50rem",
              color: theme.palette.info.dark,
              mb: `${theme.spacing(2)}!important`,
            }}
          >
            Eliminar cuenta 
          </Typography>
        </Stack>
        <Paper
          sx={{
            width: "430px",
            maxWidth: "100%",
            borderRadius: "25px",
            background: "#F8F5F3",
            marginBottom: `${theme.spacing(3)}!important`,
            padding: {
              xs: theme.spacing(6),
            },
          }}
        >
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Controller
                  name={"username"}
                  control={control}
                  render={() => (
                    <TextField
                      fullWidth
                      size="small"
                      label="Correo"
                      type="email"
                      variant="standard"
                      autoComplete="username"
                      {...register("username")}
                      error={errors.username && Boolean(errors.username)}
                      helperText={errors.username && errors.username.message}
                      sx={{
                        "& .MuiInput-root:before": {
                          borderBottomColor: "#8bc8bc!important",
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  data-name="update"
                  name="update"
                  fullWidth
                  onClick={handleSubmit(onSubmitCancelSubscription)}
                  sx={{
                    borderRadius: "0.25rem",
                    mt: 3,
                  }}
                >
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </form>
          <Typography align="center" sx={{ mt: 6 }} variant="body1">
            <LinkTo sx={{ color: theme.palette.text.primary }}
              to="/">
              Volver al inicio de sesión
            </LinkTo>
          </Typography>
        </Paper>
        <Footer />
      </Content>
    </>
  );
};

export default CancelSubscription;
